<p class="text-xs text-red-600" [id]="fieldId">
  {{ message }}
</p>
